var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.667,
    height: 24.667,
    viewBox: "0 0 24.667 24.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87280",
    "data-name": "Group 87280",
    transform: "translate(-4357 -14435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-checkmark-circle",
    "data-name": "Icon ionic-ios-checkmark-circle",
    d: "M15.708,3.375A12.333,12.333,0,1,0,28.042,15.708,12.331,12.331,0,0,0,15.708,3.375Z",
    transform: "translate(4353.625 14431.625)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25253",
    "data-name": "Rectangle 25253",
    width: 10,
    height: 3,
    transform: "translate(4364 14446)",
    fill: "#c7c7c7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/dash.e4d8560f04fbd86f978fd3975a13f5d2.svg";
export { ForwardRef as ReactComponent };